import type { StartSelfProfilerFunction } from 'owa-analytics-types';
import type { SecondaryTimingPrefix, TimingPrefix, AnnotationPrefix } from 'owa-performance-types';
import safeRequestAnimationFrame from './safeRequestAnimationFrame';
import { getQueryStringParameter } from 'owa-querystring';

const primaryTimingMap: Map<number, string> = new Map();
const secondaryTimingMap: Map<number, string> = new Map();
const annotationMap: Map<number, string> = new Map();

export function getTimingMaps(): {
    primary: Map<number, string>;
    secondary: Map<number, string>;
} {
    return { primary: primaryTimingMap, secondary: secondaryTimingMap };
}

export function getAnnotationMap(): Map<number, string> {
    return annotationMap;
}

export function clearTimingMap(): void {
    primaryTimingMap.clear();
    annotationMap.clear();
}

const secondaryActions: {
    [_ in SecondaryTimingPrefix]: boolean;
} = {
    satchelAction: true,
};

let profileFunc: StartSelfProfilerFunction | null = null;
export function setProfileFunc(func: StartSelfProfilerFunction): void {
    profileFunc = func;
}

export function addToTimingMap(prefix: TimingPrefix, value: string): void {
    if (typeof performance?.now === 'function') {
        const source = `${prefix}:${value}`;
        const timingMap = prefix in secondaryActions ? secondaryTimingMap : primaryTimingMap;
        timingMap.set(Math.floor(performance.now()), source);

        const markTimingValue = getQueryStringParameter('markTiming');
        if (markTimingValue == '*' || (markTimingValue && source.includes(markTimingValue))) {
            performance.mark(`timingMap:${source}`);
        }

        if (profileFunc) {
            const endProfile = profileFunc(source, { minDuration: 1000 });
            if (endProfile) {
                safeRequestAnimationFrame(isVisibile => {
                    setTimeout(() => {
                        endProfile(isVisibile);
                    });
                });
            }
        }
    }
}

export function addToAnnotationMap(
    prefix: AnnotationPrefix,
    value: string,
    timeParam?: number
): void {
    const time =
        timeParam ??
        (typeof performance?.now === 'function' ? Math.floor(performance.now()) : undefined);
    if (time != undefined) {
        const previousValue = annotationMap.get(time);
        annotationMap.set(time, `${previousValue ? `${previousValue}&` : ''}${prefix}:${value}`);
    }
}
